import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

import { MenuAccessApiResponse } from '../../types/api/menuAccessApi';
import { getMenuAccessDataService } from '../../api/menuAccessApi';
import { MenuAccessState } from '../../types/features/menuAccessSlice';



export const getMenuAccessData = createAsyncThunk<MenuAccessApiResponse>(
    'menuAccess/getMenuAccessData',
    async () => {
        const response = await getMenuAccessDataService();
        return response.data; // Assumes response has a 'data' property
    }
);

const menuAccessSlice = createSlice({
    name: 'menuAccess',
    initialState: {
       
        menu: [],
       menuLoader:false,
        status: false,
        msg: ''
    } as MenuAccessState, 
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getMenuAccessData.pending, (state) => {
                state.menuLoader = true;
            })
            .addCase(getMenuAccessData.fulfilled, (state, action: PayloadAction<MenuAccessApiResponse>) => {
                state.menu = action.payload.data;
                state.msg = action.payload.message;
                state.status = true;
                state.menuLoader = false;
            })
            .addCase(getMenuAccessData.rejected, (state, action) => {
                state.menuLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })
     
    }
});

export default menuAccessSlice.reducer;
